import { supabase } from '../lib/supabase';

export const workforceAnalyticsService = {
  async getDepartmentalStaffingBreakdown(filters = {}) {
    let query = supabase?.from('employees')?.select('department, employment_type, is_active')?.eq('is_active', true);
    
    if (filters?.departments && filters?.departments?.length > 0) {
      query = query?.in('department', filters?.departments);
    }
    
    if (filters?.employmentTypes && filters?.employmentTypes?.length > 0) {
      query = query?.in('employment_type', filters?.employmentTypes);
    }
    
    const { data, error } = await query;
    
    if (error) throw error;
    
    // Group by department and employment type
    const breakdown = {};
    
    data?.forEach(employee => {
      const dept = employee?.department || 'Unassigned';
      
      if (!breakdown?.[dept]) {
        breakdown[dept] = {
          department: dept,
          permanent: 0,
          contract: 0,
          casual: 0,
          temporary: 0,
          total: 0
        };
      }
      
      const empType = employee?.employment_type;
      if (empType === 'full_time') {
        breakdown[dept].permanent += 1;
      } else if (empType === 'fixed_term') {
        breakdown[dept].contract += 1;
      } else if (empType === 'casual') {
        breakdown[dept].casual += 1;
      } else if (empType === 'non_citizen') {
        breakdown[dept].temporary += 1;
      }
      
      breakdown[dept].total += 1;
    });
    
    return Object.values(breakdown);
  },

  async getWorkforceKPIs(filters = {}) {
    let query = supabase?.from('employees')?.select('employment_type, citizen_status, is_active');
    
    if (filters?.departments && filters?.departments?.length > 0) {
      query = query?.in('department', filters?.departments);
    }
    
    const { data, error } = await query;
    
    if (error) throw error;
    
    const totalEmployees = data?.filter(e => e?.is_active)?.length || 0;
    const permanentCount = data?.filter(e => e?.is_active && e?.employment_type === 'full_time')?.length || 0;
    const citizenCount = data?.filter(e => e?.is_active && e?.citizen_status === 'citizen')?.length || 0;
    const contractCount = data?.filter(e => e?.is_active && e?.employment_type === 'fixed_term')?.length || 0;
    
    return {
      totalEmployees,
      permanentCount,
      citizenCount,
      contractCount,
      citizenPercentage: totalEmployees > 0 ? ((citizenCount / totalEmployees) * 100)?.toFixed(1) : 0,
      permanentPercentage: totalEmployees > 0 ? ((permanentCount / totalEmployees) * 100)?.toFixed(1) : 0
    };
  },

  async getEmploymentDistribution(filters = {}) {
    let query = supabase?.from('employees')?.select('employment_type, is_active')?.eq('is_active', true);
    
    if (filters?.departments && filters?.departments?.length > 0) {
      query = query?.in('department', filters?.departments);
    }
    
    const { data, error } = await query;
    
    if (error) throw error;
    
    const distribution = {
      full_time: 0,
      fixed_term: 0,
      casual: 0,
      non_citizen: 0
    };
    
    data?.forEach(employee => {
      const type = employee?.employment_type;
      if (distribution?.hasOwnProperty(type)) {
        distribution[type] += 1;
      }
    });
    
    return [
      { name: 'Permanent', value: distribution?.full_time },
      { name: 'Contract', value: distribution?.fixed_term },
      { name: 'Casual', value: distribution?.casual },
      { name: 'Temporary', value: distribution?.non_citizen }
    ];
  },

  async getCitizenshipDistribution(filters = {}) {
    let query = supabase?.from('employees')?.select('citizen_status, is_active')?.eq('is_active', true);
    
    if (filters?.departments && filters?.departments?.length > 0) {
      query = query?.in('department', filters?.departments);
    }
    
    const { data, error } = await query;
    
    if (error) throw error;
    
    const citizenCount = data?.filter(e => e?.citizen_status === 'citizen')?.length || 0;
    const nonCitizenCount = data?.filter(e => e?.citizen_status === 'non_citizen')?.length || 0;
    
    return [
      { name: 'PNG Citizens', value: citizenCount },
      { name: 'Non-Citizens', value: nonCitizenCount }
    ];
  },

  async getDepartmentList() {
    const { data, error } = await supabase?.from('employees')?.select('department')?.not('department', 'is', null)?.eq('is_active', true);
    
    if (error) throw error;
    
    const departments = [...new Set(data?.map(e => e?.department))];
    return departments?.sort();
  }
};